import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块,post数据需要qs格式化
import base from './base'// 导入接口域名列表
//合作商、搭档相关接口
;

const myAllWork = {
  //列表数据
  getPage(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/partner/tabPartner/page`, params);
  },
  //根据id查询单个信息
  getById(params) {
    return axios.get(`${base.bs}/admin/partner/tabPartner/get/${params.id}`)
  },
  //保存修改
  saveOrUpdate(params) {
    return axios.post(`${base.bs}/admin/partner/tabPartner/set`, params)
  },
  //根据id删除单个
  del(params) {
    return axios.get(`${base.bs}/admin/partner/tabPartner/del/${params.id}`)
  },
  //批量删除
  batchDel(params) {
    return axios.get(`${base.bs}/admin/partner/tabPartner/batchDel?ids=${params.ids}`,null)
  },
}
// 导出接口
export default myAllWork;



// WEBPACK FOOTER //
// ./src/request/api/tabPartner.js